import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import './ServiciosPage.css';
import Header from './Header';
import AnimatedBackground from './AnimatedBackground';

const ServiciosPage = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigateToPage = (path) => {
    window.history.pushState({}, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  const hubCards = useMemo(() => ([
    { path: '/tienda', icon: 'shopping-bag', titleKey: 'serviciosHub.storeTitle', descKey: 'serviciosHub.storeDesc', ctaKey: 'serviciosHub.storeCta', tone: 'ink' },
    { path: '/bienestar', icon: 'spa', titleKey: 'serviciosHub.wellnessTitle', descKey: 'serviciosHub.wellnessDesc', ctaKey: 'serviciosHub.wellnessCta', tone: 'forest' },
    { path: '/conecta-tu-camino', icon: 'route', titleKey: 'serviciosHub.connectTitle', descKey: 'serviciosHub.connectDesc', ctaKey: 'serviciosHub.connectCta', tone: 'mist' },
    { path: '/voluntariado', icon: 'hands-helping', titleKey: 'serviciosHub.volunteerTitle', descKey: 'serviciosHub.volunteerDesc', ctaKey: 'serviciosHub.volunteerCta', tone: 'clay' },
    { path: '/conoce-colombia', icon: 'map-marked-alt', titleKey: 'serviciosHub.travelTitle', descKey: 'serviciosHub.travelDesc', ctaKey: 'serviciosHub.travelCta', tone: 'earth' },
    { path: '/growth-partner', icon: 'chart-line', titleKey: 'serviciosHub.growthTitle', descKey: 'serviciosHub.growthDesc', ctaKey: 'serviciosHub.growthCta', tone: 'wine' },
  ]), []);

  return (
    <div className="servicios-page">
      <Header />
      <AnimatedBackground particleCount={4} staticCount={2} />

      <section className="servicios-hub-hero">
        <div className="servicios-container">
          <span className="servicios-hub-kicker">{t('serviciosHub.kicker')}</span>
          <h1 className="servicios-hub-title">{t('serviciosHub.heroTitle')}</h1>
          <p className="servicios-hub-lead">{t('serviciosHub.heroLead')}</p>
          <p className="servicios-hub-trust">{t('serviciosHub.trustLine')}</p>
          <div className="servicios-hub-actions">
            <button type="button" className="servicios-hub-btn servicios-hub-btn-primary" onClick={() => navigateToPage('/contacto')}>
              {t('serviciosHub.primaryCta')}
            </button>
            <button type="button" className="servicios-hub-btn servicios-hub-btn-ghost" onClick={() => navigateToPage('/bienestar')}>
              {t('serviciosHub.secondaryCta')}
            </button>
          </div>
        </div>
      </section>

      <section className="servicios-hub-grid-section">
        <div className="servicios-container">
          <h2 className="servicios-hub-grid-title">{t('serviciosHub.gridTitle')}</h2>
          <div className="servicios-hub-cards">
            {hubCards.map((card) => (
              <article
                key={card.path}
                className={`servicios-hub-card servicios-hub-card--${card.tone}`}
                onClick={() => navigateToPage(card.path)}
              >
                <div className="servicios-hub-card-icon"><i className={`fas fa-${card.icon}`} /></div>
                <h3 className="servicios-hub-card-heading">{t(card.titleKey)}</h3>
                <p className="servicios-hub-card-text">{t(card.descKey)}</p>
                <button type="button" className="servicios-hub-card-cta" onClick={(e) => { e.stopPropagation(); navigateToPage(card.path); }}>
                  {t(card.ctaKey)}
                </button>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="servicios-hub-bottomcta">
        <div className="servicios-container servicios-hub-bottom-inner">
          <p>{t('serviciosHub.bottomCta')}</p>
          <button type="button" className="servicios-hub-bottom-btn" onClick={() => navigateToPage('/contacto')}>{t('serviciosHub.bottomBtn')}</button>
        </div>
      </section>
    </div>
  );
};

export default ServiciosPage;
